import { create } from "zustand";
import { devtools as devtoolsMiddleware } from "zustand/middleware";

const devtools = import.meta.env.DEV
  ? devtoolsMiddleware
  : (((fn: unknown) => fn) as typeof devtoolsMiddleware);

interface ChatUIState {
  isPanelMinimized: boolean;
  togglePanelMinimized: () => void;
  setPanelMinimized: (minimized: boolean) => void;
}

export const useChatUIStore = create<ChatUIState>()(
  devtools(
    (set) => ({
      isPanelMinimized: false,

      togglePanelMinimized: () =>
        set(
          (state) => ({ isPanelMinimized: !state.isPanelMinimized }),
          false,
          "chatUI/togglePanelMinimized"
        ),

      setPanelMinimized: (minimized) =>
        set({ isPanelMinimized: minimized }, false, "chatUI/setPanelMinimized"),
    }),
    { name: "ChatUIStore" }
  )
);
